import React, { useCallback, useContext } from "react";
import { DataContext } from "../../DataContext";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng
} from "use-places-autocomplete";
import {
  Combobox,
  ComboboxInput,
  ComboboxPopover,
  ComboboxList,
  ComboboxOption
} from "@reach/combobox";
import "@reach/combobox/styles.css";
import searchIcon from "../../assets/images/icons/search.svg";
import clearIcon from "../../assets/images/icons/clear.svg";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

const BlueToolTip = withStyles(theme => ({
  tooltip: {
    backgroundColor: "#0016C7;",
    fontFamily: "Work Sans, sans",
    fontWeight: 600,
    fontSize: 12,
    letterSpacing: 0.5,
    padding: 10
  }
}))(Tooltip);

const SearchField = props => {
  const { mapRef, onSearchSubmit, currentSearchValue } = props;
  const [searchResults, updateResults] = useContext(DataContext);
  //const [searchResults] = useContext(DataContext);

  const panTo = useCallback(({ lat, lng }) => {
    mapRef.current.panTo({ lat, lng });
    mapRef.current.setZoom(10);
  }, []);

  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions
  } = usePlacesAutocomplete({
    // requestOptions: {
    //   //set bias for location options
    //   location: {
    //     lat: () => mapRef.current.center.lat,
    //     lng: () => mapRef.current.center.lng
    //   },
    //   radius: 100 * 1000
    // }
  });

  //console.log(mapRef.current.center);

  // https://developers.google.com/maps/documentation/javascript/reference/places-autocomplete-service#AutocompletionRequest

  const handleInput = e => {
    setValue(e.target.value);
  };

  const searchClickHandler = () => {
    handleSelect(value);
  };

  const clearClickHandler = () => {
    clearSuggestions();
    setValue("");
  };

  const handleAnalytics = () => {
    console.log("hello zip");
    //var ans = $('.searchField input').val();
    if (value != "") {
      let dataLayer = [];
      dataLayer.push({
        event: "pfPharmacyFinder",
        pfPharmacyFinder: {
          zipCode: value, //queried zip code
          pharmacyPageLoad: "false" //true or false,
        }
      });
      var event = new CustomEvent("pfAnalytics", {
        detail: dataLayer
      });
      document.querySelector("body").dispatchEvent(event);
    }
  };

  const handleSelect = async address => {
    setValue(address, false);
    clearSuggestions();
    try {
      const results = await getGeocode({ address });
      const { lat, lng } = await getLatLng(results[0]);
      //const currentState = results[0].address_components[4].short_name;
      panTo({ lat, lng });
      //send raw search result date to DataContext for global use
      updateResults(results);
      onSearchSubmit(value);
    } catch (error) {
      console.log("😱 Error: ", error);
    }
  };

  // useEffect(() => {
  //   console.log(currentSearchValue);
  // }),
  //   [];

  return (
    <div className="searchField">
      <Combobox onSelect={handleSelect}>
        <ComboboxInput
          value={value}
          onChange={handleInput}
          disabled={!ready}
          placeholder="Enter zip code, city, or state"
          className={"comboBoxInput"}
          onKeyPress={event => {
            if (event.key === "Enter") {
              searchClickHandler();
              handleAnalytics();
            }
          }}
          onClick={() => {
            handleAnalytics();
          }}
          //maxLength="25"
        />
        <button onClick={() => searchClickHandler()} className={"searchBtn"}>
          <img
            alt="Magnifying glass icon"
            src={searchIcon}
            onClick={() => {
              handleAnalytics();
            }}
          />
        </button>
        {value.length > 0 ? (
          <BlueToolTip title="CLEAR RESULTS" placement="bottom" arrow>
            <button onClick={() => clearClickHandler()} className={"clearBtn"}>
              <img alt="Pink X icon" src={clearIcon} />
            </button>
          </BlueToolTip>
        ) : null}
        <ComboboxPopover>
          <ComboboxList>
            {status === "OK" &&
              data.map(({ place_id, description }) => {
                //limit result to 34 char
                // if (description.length > 34)
                //   description = description.substring(0, 34);
                return (
                  <ComboboxOption
                    key={place_id}
                    value={description}
                    onClick={() => {
                      handleAnalytics();
                    }}
                  />
                );
              })}
          </ComboboxList>
        </ComboboxPopover>
      </Combobox>
    </div>
  );
};

export default SearchField;
